import ClearIcon from "@mui/icons-material/Clear";
import { observer } from "mobx-react-lite";
import { AdditionalParameter, APISetupType, ExternalAPIParameterButtons, TitleText, useExternalAPIWizardStore } from "./ExternalAPIWizardStore";
import React, { FunctionComponent } from "react";
import { Button, FlexColumn, FlexRowCenter, FormField, GridRow, IconButton, SplitButton, Text, TextField } from "designSystem/index";
import { grey } from "designSystem/styles/color";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";

interface ExternalAPIAdditionalParametersProps  {
	/** Container of Additional Parameters */
	externalAPIAdditionalParameters: Array<AdditionalParameter>;
	/** setup type of parameter, Authentication or Connector */
	setupType: APISetupType;
}

export const ExternalAPIAdditionalParametersComponent: FunctionComponent<ExternalAPIAdditionalParametersProps> = observer((props) => {
	const store = useExternalAPIWizardStore();
	const {
		getAdditionalParameterTitle,
		getAdditionalParameterKeyText, 
		getAdditionalParameterValueText, 
		onAddParameter,
		onRemoveParameter,
		setParameterKey, 
		setParameterValue, 
	} = store;
	const { externalAPIAdditionalParameters, setupType } = props;
	return (
		<>
			<TitleText text={getAdditionalParameterTitle(setupType)} />
			{externalAPIAdditionalParameters.map((parameter, index) => (
				<FlexColumn
					bgcolor={grey[100]}
					border={STANDARD_BORDER_STYLE}
					borderRadius={1}
					key={index}
					pl={2}
					pt={2}
				>
					<FlexRowCenter key={index} width="47%">
						<FormField
							control={(
								<TextField
									autoFocus
									fullWidth
									onChange={(e) => {setParameterKey(externalAPIAdditionalParameters, index, e.target.value);}}
									value={externalAPIAdditionalParameters[index].key}
								/>
							)}
							fullWidth
							label={<Text bold text={getAdditionalParameterKeyText(parameter.type)} />}
							labelPlacement="top"
							sx={{ pr : 2 }}
						/>
						<FormField
							control={(
								<TextField
									autoFocus
									fullWidth
									onChange={(e) => {setParameterValue(externalAPIAdditionalParameters, index, e.target.value);}}
									value={externalAPIAdditionalParameters[index].value}
								/>
							)}
							fullWidth
							label={<Text bold text={getAdditionalParameterValueText()} />}
							labelPlacement="top"
							sx={{ pr : 2 }}
						/>
						<IconButton
							design="default"
							onClick={() => { onRemoveParameter(setupType, index); }}
							size="large"
						>
					        <ClearIcon />
				        </IconButton>
					</FlexRowCenter>
				</FlexColumn>
			))}
			<GridRow
				pt={2}
			>
				{ setupType === APISetupType.GENERAL ?
					(
						<Button
							design="secondary"
							onClick={(e) => onAddParameter(setupType, null)}
							res="AddExternalAPIAddGeneralBtn"
						/>
					) :
					<SplitButton buttons={ExternalAPIParameterButtons} onClick={(e) => onAddParameter(setupType, e.res)} />
				}
			</GridRow>
		</>
	);
});